export default __webpack_public_path__ + "static/media/step-2.14bb6518.webp";